import { render, staticRenderFns } from "./SoftTable.vue?vue&type=template&id=74c4bab4&"
import script from "./SoftTable.vue?vue&type=script&lang=js&"
export * from "./SoftTable.vue?vue&type=script&lang=js&"
import style0 from "./SoftTable.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports